import React from 'react';

import { Scrollbars } from 'react-custom-scrollbars';


class PreventPageScrollingScrollbars extends React.Component {
  constructor(props) {
    super(props);
    this.handleWindowWheel = this.handleWindowWheel.bind(this);
    this.state = {
      mouseOverContent: false,
    };
  }

  componentDidMount() {
    window.addEventListener('mousewheel', this.handleWindowWheel, false);
  }

  componentWillUnmount() {
    window.removeEventListener('mousewheel', this.handleWindowWheel);
  }

  getInstance() {
    return this.refs.scrollbars;
  }

  handleWindowWheel(e) {
    if (!this.state.mouseOverContent) {
      return;
    }

    const {
      top,
      left,
      clientHeight,
      scrollLeft,
      scrollHeight,
    } = this.refs.scrollbars.getValues(); // Get this from your ref

    // When the bottom or top is reached and we're scrolling down or up
    // respectively, prevent scrolling of the window.

    // handle horizontal scroll
    if (
      left > 0 && scrollLeft > 0
    ) {
      e.preventDefault();
    } else if
    (
      (top >= 0.99 && e.deltaY > 0) ||
					(top <= 0 && e.deltaY < 0)
    ) {
      e.preventDefault();
    }
  }

  render() {
    return (
      <Scrollbars
        onMouseEnter={() => {
					this.setState({ mouseOverContent: true });
				}}
        onMouseLeave={() => {
					this.setState({ mouseOverContent: false });
				}}
        ref="scrollbars"
        {...this.props}
      />
    );
  }
}

module.exports = PreventPageScrollingScrollbars;
